import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';
import { formatFormCreate, formatFormEdit } from '../utils';
import { showNotificationLayer } from '../../../actions/notification';
import { create as c, update as u, details } from '../../../api/common';

const loadingPostManager = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const update = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    u(params.formParams, 'user.php')
      .then(response => {
        dispatch(loadingPostManager());
        dispatch(hideFormManagerLayer());

        dispatch({ type: TYPES.updateItemListing, payload: response });

        dispatch(
          showNotificationLayer(`O usuário ${response.data.name} foi atualizado!`)
        );
      })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
};

export const create = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    c(params.formParams, 'user.php')
      .then(response => {
        dispatch(loadingPostManager());
        dispatch(hideFormManagerLayer());

        dispatch({
          type: TYPES.insertItemListingManagerSuccess,
          payload: response,
        });

        dispatch(
          showNotificationLayer(`O usuário ${response.data.name} foi criado!`)
        );
      })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
};

export const showFormManagerLayer = params => {
  if(params && params.id) {
    //ga
    analytics.registerEvent({
      category: analytics.categories.user,
      action: analytics.actions.userEdit,
    });

    return dispatch => {
      dispatch([
        { type: COMMON_TYPES.toggleLayer, payload: 'manager' },
        { type: COMMON_TYPES.formGetWatingResponse, payload: true },
      ]);

      details({ id: params.id, path: 'user.php' })
        .then(({ data }) => {
          dispatch([{
              type: COMMON_TYPES.formInitializeValues,
              payload: formatFormEdit(data),
            },
            { type: COMMON_TYPES.formGetWatingResponse, payload: false },
          ])
        })
        .catch(() =>
          dispatch({ type: COMMON_TYPES.formGetResultError })
        )
    }
  }

  //ga
  analytics.registerEvent({
    category: analytics.categories.user,
    action: analytics.actions.userCreate,
  });

  return [
    { type: COMMON_TYPES.toggleLayer, payload: 'manager' },
    { type: COMMON_TYPES.formInitializeValues, payload: formatFormCreate() },
    { type: COMMON_TYPES.formGetWatingResponse, payload: false },
  ];
};

export const hideFormManagerLayer = () => {
  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
